export default __webpack_public_path__ + "static/media/loginBackground.de8cf7af.svg";